import { useSelector } from 'react-redux';
import './App.css';
import AuthenticatedRoutes from './containers/AuthenticatedRoutes';
import UnAuthenticatedRoutes from './containers/UnAuthenticatedRoutes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import AlertStack from './reusable_components/components/AlertStack';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {

  const { Profile } = useSelector((state) => state.common)
  const location = useLocation()
  const navigate = useNavigate()

  let roleRoute;
  if (Profile?.profile?.isExternalRecruiter === 'N' && Profile?.profile?.role === 'recruiter') {
    roleRoute = '/dashboard'
    // } else if (Profile?.profile?.isExternalRecruiter === 'Y' && Profile?.profile?.role === 'recruiter' && Profile?.profile?.levelTwoApproval === 'N') {
    //   roleRoute = '/profile-view'
  } else if (Profile?.profile?.isExternalRecruiter === 'Y' && Profile?.profile?.role === 'recruiter') {
    roleRoute = '/jobpost'
  }

  useEffect(() => {
    // Check authentication status when the location changes
    if (location.pathname === '/') {
      if (Object.keys(Profile).length === 0) {
        navigate('/');
      } else {
        navigate(roleRoute ? roleRoute : '/dashboard');
      }
    }
  }, [location.pathname, Profile, navigate]);

  const getRoutes = () => {
    if (Object.keys(Profile).length > 0) {
      return <AuthenticatedRoutes />;
    }
    if (Object.keys(Profile).length === 0) {
      return <UnAuthenticatedRoutes />;
    }
  }

  return (
    <div>
      {getRoutes()}
      <AlertStack />
      <ToastContainer />
    </div>
  );
}

export default App;
